import { UserDefinedNotificationTrigger } from '@apis/Notification/model';
import { BellRinging, Icon, QuestionMark, Report } from 'tabler-icons-react';
import { describeAlert } from './Alert';
import { describeSchedule } from './Schedule';

interface TriggerDescription {
    icon: Icon;
    brief: string;
    description: string;
    type: string;
}
export function describeTrigger(trigger: UserDefinedNotificationTrigger): TriggerDescription | null {
    switch (trigger.TriggerType) {
        case 'Schedule':
            return !trigger.Schedule ? null : describeSchedule(trigger.Schedule);
        case 'Threshold':
            return !trigger.Threshold ? null : describeAlert(trigger.Threshold);
        default:
            return null;
    }
}
export function describeBaseTrigger(triggerType?: 'Schedule' | 'Threshold'): { icon: Icon; type: string } {
    switch (triggerType) {
        case 'Schedule':
            return { icon: Report, type: 'Scheduled Report' };
        case 'Threshold':
            return { icon: BellRinging, type: 'Alert' };
        default:
            return { icon: QuestionMark, type: 'Unspecified' };
    }
}
